import { Chip } from "@heroui/react";

import { useTranslations } from "@/src/i18n/i18n";

type EventStatus = "open" | "close" | "complete";

/**
 * ⚠️ **Les trois statuts du serveur ne veulent pas dire ce que leur nom
 * suggère**, et les confondre fait lire l'inverse de la vérité :
 *
 * - `open` — les candidatures sont ouvertes, il reste des places ;
 * - `complete` — l'effectif est au complet ; la partie n'a pas encore eu lieu
 *   (`validateParticipant` y bascule quand la dernière place est validée, et
 *   une désinscription ramène à `open`) ;
 * - `close` — **terminé** : les vainqueurs ont été désignés, c'est l'état
 *   final (`setWinners` appelle `closeEvent`).
 *
 * D'où des libellés qui ne recopient pas les codes.
 */
const STATUS_KEY = {
  open: "status-open",
  complete: "status-complete",
  close: "status-close",
} as const satisfies Record<EventStatus, string>;

const STATUS_COLOR = {
  open: "success",
  complete: "warning",
  close: "default",
} as const satisfies Record<EventStatus, "default" | "success" | "warning">;

/** Le statut d'un événement, lu pareil sur la liste et sur la fiche. */
export function EventStatusChip({ status }: { status: EventStatus }) {
  const t = useTranslations("events");

  return (
    <Chip color={STATUS_COLOR[status]} size="sm">
      {t(STATUS_KEY[status])}
    </Chip>
  );
}
